<template>
    <UFormField
        :label
        :name
        class="self-stretch justify-start text-black text-sm font-normal font-dm-sans"
        :ui = "{
            root: 'self-stretch w-full',
        }">
        <UInput
            v-model="model"
            :placeholder
            :icon="icon"
            :type
            variant="none"
            class="text-neutral-500 text-sm font-normal font-dm-sans"
            :ui="{
                root: 'self-stretch h-10 px-4 w-full rounded-3xl outline outline-1 outline-offset-[-1px] outline-neutral-200 hover:outline-neutral-300 active:outline-neutral-400 focus:outline-3 focus:outline-blue-300 disabled:bg-neutral-100 disabled:text-neutral-400 inline-flex items-center',
                leading: 'p-4'
            }">
            <slot name="trailing"/>
        </UInput>
    </UFormField>
</template>


<script lang="ts" setup>

withDefaults(defineProps<{
    label: string,
    name: string,
    placeholder?: string,
    type?: 'text' | 'password'
    icon?: string,
    modelValue: string,
}>(),
{
    type: 'text',
})

const model = defineModel<string>()
</script>